import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
/**
 * Renders a fragment. We required a wrapper because of props compatibility.
 * @returns
 */
export function FragmentComponent() {
    return _jsx(Fragment, {});
}
//# sourceMappingURL=FragmentComponent.js.map